import React, { useEffect, useState, useContext } from "react"
import { Link } from "react-router-dom";
import Slidewithindicator from "./slidewithindicator"
import ReactBSAlert from "react-bootstrap-sweetalert";
import {ViolationsContext} from "components/Common/PageDataContext";
import jsPDF from 'jspdf';
import img2 from "../../assets/images/Ador_logo_cropped.png"
import Select from "react-select";
import { apiEndpoint } from "helpers/url_helper";


//import { ActiveImageContext } from './ViolationImageContext';


import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  ModalFooter,
  UncontrolledTooltip,

} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { func, string } from "prop-types";
import { eventChannel } from "redux-saga";
import { result, some } from "lodash";

import jwt from "jsonwebtoken";

const EditViolationModalComponent = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [ANPRVal, setANPR] = useState();
  const [imgData, setImageData] = useState();
  const [alertmsg, setAlert] = useState();
  const { violations, setViolations } = useContext(ViolationsContext);
  const [violationImageIndex, setViolationImageIndex] = useState(0);
  var violationImage = '';
  const [showGenerateChallanButton, setshowGenerateChallanButton] = React.useState(false);
  const[ViolationRegNo, setViolationRegNo] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modal_small, setmodal_small] = useState(false);
  const [SelectedChallanType, setSelectedChallanType] = useState({ value: 1, label: "Penalty" });
  const [TotalViolationFreq, setTotalViolationFreq] = useState();
  const [EmailPDFCheck, setEmailPDFCheck] = useState(false);
  const [ showDeleteButton, setShowDeleteButton] = useState(false);



  let newdata = [];
  let updatedViolationData;

  const [CompanyName, setCompanyName] = useState();
  const [CompanyAddress1, setNewCompanyAddress1] = useState();
  const [CompanyAddress2, setNewCompanyAddress2] = useState();
  const [CityName, setCityName] = useState();
  const [StateName, setStateName] = useState();
  const [NewChallanAmount, setNewChallanAmount] = useState();
  const [ChallanDetailsResponse, setChallanDetailsResponse] = useState();
  const [ ChallanType, setChallanType] = useState("Penalty");
  const [ChallanID, setChallanID] = useState();
  const [CompanyLogo, setCompanyLogo] = useState();
  const [SecondaryCompanyLogo, setSecondaryCompanyLogo] = useState();
  const[showEmailButton, setShowEmailButton] = useState(false);
  const[showSMSButton, setShowSMSButton] = useState(false);
  const [ DuplicateChallan, setDuplicateChallan]= useState(false);
    const [regNoViolations, setRegNoViolations] = useState([]);
    const [showFreqModal, setShowFreqModal] = useState(false);
    const [freqViolations, setFreqViolations] = useState([]);
var CompanyLocationName = '';
  //const ImgContextvalue = { violationImageIndex, setViolationImageIndex };
  

  const tog_small = () => {
    debugger;
    setmodal_small(!modal_small)
    document.body.classList.add("no_padding")
  }



  const handleChangeChallanType = event => {
    
    setSelectedChallanType(event);
    setChallanType(event.label);  
    console.log("Select Challan Type------>",SelectedChallanType);
    console.log("Challan Type--->", ChallanType);
    
  };

useEffect(() => {
  debugger;
   
  if(props.ViolationData.CampusID != null)
  {
      const intCampusID = props.ViolationData.CampusID;
      console.log("CampusID going to GetEmailSMSStatus API =>", intCampusID);
    // UserValidated
    fetch(apiEndpoint+"/GetEmailSMSStatus",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "intCampusID": intCampusID,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      })
        /* .then(res => res.json())*/
        .then((res) => {
            console.log("Raw Response:", res);
            return res.json(); // MUST RETURN
        })
    .then(
      (result) =>{
            debugger;
         console.log("Parsed JSON:", result);

            if (result !== undefined && result !== null && result !== "")
        {
            if(result.EnableEmail == 1)
            {
              setShowEmailButton(true);
            }
            else{
              setShowEmailButton(false);
            }
            if(result.EnableSMS == 1)
            {
              setShowSMSButton(true);
            }
            else{
              setShowSMSButton(false);
            }
        }
      }
    )
  }

},[props.ViolationData.CampusID]);
    useEffect(() => {
        if (!props?.ViolationData?.RegistrationNumber) return;

        const payload = {
            RegistrationNumber: props.ViolationData.RegistrationNumber,
            strToken: sessionStorage.getItem("Clear_AuthUser")
        };

        fetch(apiEndpoint + "/GetAllViolationsByRegNo", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.status === true) {
                    setRegNoViolations(data.Violations);
                } else {
                    setRegNoViolations([]);
                }
            });
    }, [props.ViolationData.RegistrationNumber]);
const ChallanTypeDropdown = [
  {
    value: 1,
    label: "Penalty"
  },
  {
    value: 2,
    label: "Warning"
  }
];

const GetChallanConfig = (violationData) =>{

 debugger;
  var intCampusID = violationData.CampusID;
    setTotalViolationFreq(violationData.TotalViolationFrequency);

    // UserValidated
  fetch(apiEndpoint+"/GetChallanConfigDetails",
  {
  method:"POST",
    headers: {
      'Content-Type': 'application/json',
      // 'Access-Control-Allow-Origin': '*',
    },
    body: JSON.stringify({
      "intCampusID": intCampusID,
      "strToken": sessionStorage.getItem("Clear_AuthUser")
    })
  })
  .then(res => res.json())
  .then((data) => {
    debugger;

    if (data.ChallanConfigDetails != null) {
      setCompanyName(data.ChallanConfigDetails.CompanyName);
      setNewCompanyAddress1(data.ChallanConfigDetails.AddressLine1);
      setNewCompanyAddress2(data.ChallanConfigDetails.AddressLine2);
      setCityName(data.ChallanConfigDetails.City);
      setStateName(data.ChallanConfigDetails.State);
      setNewChallanAmount(data.ChallanConfigDetails.ChallanAmount);
      setCompanyLogo(data.base64Image);
      setSecondaryCompanyLogo(data.secondBase64Image);
      setDuplicateChallan(data.ChallanConfigDetails.DuplicateChallan);



    }
    else {
      setModalOpen(false);
      setAlert(
        <ReactBSAlert
          warning
          //   style={bsAlertStyle}
          //   title="Good job!"
          onConfirm={event =>  window.location.href='/ChallanSettings'}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="warning"
          cancelBtnBsStyle="secondary"
          showCancel
          reverseButtons 
        >
          {"Challan Details Not Available"}
          <br /> 
          {"Can we Redirect you to Challan Settings Page ?"}
          
        </ReactBSAlert>
      )
      setCompanyName('');
      setNewCompanyAddress1('');
      setNewCompanyAddress2('');
      setCityName('');
      setStateName('');
      setNewChallanAmount('');
      setDuplicateChallan(false);

    }

  });

    }
    const handleFrequencyClick = (freq, regNo) => {
        // Get all violations for this Registration Number where frequency < selected frequency
        debugger;
        const filtered = regNoViolations.filter(
            (x) => x.RegistrationNumber === regNo && x.ViolationFrequency < freq
        );

        setFreqViolations(filtered);
        setShowFreqModal(true);
    };

    const DownloadPDF = (violationData, NewANPRVal, ChallanID) => {
    debugger;

    let VehicleOwner = violationData.VehicleOwnerName || "NA";
    let Department = violationData.VehicleOwnerDept || "NA";
    let EICName = violationData.ManagerName || "NA";
        let RegistrationNumber = NewANPRVal || violationData.RegistrationNumber || " ";
    let img = `data:image/png;base64,${CompanyLogo}`;

        //let IncidentTime = violationData.IncidentTime || "NA";
        let IncidentTime = violationData.IncidentTime ? violationData.IncidentTime.replace('T', ' ') : "NA";
        let formattedDate = "NA";
        let formattedTime = "NA";
        if (IncidentTime !== "NA") {
            // Split into date and time parts
            let [datePart, timePart] = IncidentTime.split(' ');

            // Format the date
            let dateObj = new Date(IncidentTime);
            const optionsDate = { day: '2-digit', month: 'short', year: 'numeric' };
            formattedDate = dateObj.toLocaleDateString('en-GB', optionsDate).replace(/ /g, '-');

            // Format the time
            const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: true };
            formattedTime = dateObj.toLocaleTimeString('en-US', optionsTime);
        }
        console.log("Date:", formattedDate); 
        console.log("Time:", formattedTime); 
    let LocationName = violationData.LocationName || "NA";
    let AmountInWords = numberToWords(NewChallanAmount);
    let VendorCode = violationData.VendorCode || " ";
    let EC_EPNo = violationData.EC_EPNo || " ";
    let LicenceNo = violationData.LicenceNo || " ";
    let ChallanAmount = '' + NewChallanAmount ;
    let UniqueChallanID = '' + ChallanID;
        console.log(UniqueChallanID)
    // Image setup
    let violationImage = '';
    if (violationImageIndex != null && imgData && imgData.ViolationImgBase64Img) {
        violationImage = `data:image/png;base64,${imgData.ViolationImgBase64Img[violationImageIndex]}`;
    }

    function numberToWords(num) {
        const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
            'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        if (num === 0) return 'Zero';
        if (num < 20) return a[num];
        if (num < 100) return b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '');
        if (num < 1000) return a[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + numberToWords(num % 100) : '');
        if (num < 10000) return a[Math.floor(num / 1000)] + ' Thousand' + (num % 1000 ? ' ' + numberToWords(num % 1000) : '');
        return num.toString(); 
    }

    const doc = new jsPDF('p', 'mm', 'a4');
    doc.setFont('times', 'normal');
    doc.setFontSize(12);

    let startY = 10;

    // Title
    doc.setFontSize(16);
    doc.setFont('times', 'bold');
        doc.text("Reliance Group Support Services Pvt. Ltd.", 105, startY, { align: "center" });
        // Title
        doc.setFontSize(16);
        doc.setFont('times', 'bold');
        doc.text("Reliance Group Support Services Pvt. Ltd.", 105, startY, { align: "center" });

        // Add the logo image at the top-right corner
        const logoWidth = 30;   // Adjust width
        const logoHeight = 15;  // Adjust height
        const logoX = 180;      // X position (right corner)
        const logoY = startY - 5; // Y position slightly above or aligned with text
        doc.addImage(img, 'PNG', logoX, logoY, logoWidth, logoHeight);


    // Address
    doc.setFontSize(10);
    doc.setFont('times', 'normal');
    startY += 6;
    doc.text("Correspondence Address : Village - Motikhavdi, P. O. Digvijaygram - 361140, District - Jamnagar. (Gujarat)", 105, startY, { align: "center" });
    startY += 4;
    doc.text("Tel. No. : (0288) 6611911, 6621010 E-mail : JMDsecurity.Operationscentre@ril.com", 105, startY, { align: "center" });

    // Horizontal line
    startY += 4;
    doc.setLineWidth(0.5);
    doc.line(10, startY, 200, startY);

        // Reference line
        startY += 6;
        doc.setFont('times', 'normal');

        // Text 1: DN. Ref No./Traffic / EC_EPNo
        //const refText = `DN. Ref No./Traffic / ${EC_EPNo}`;
        //doc.text(refText, 14, startY);

        //// Draw underline for refText
        //const refTextWidth = doc.getTextWidth(refText);
        //doc.line(14, startY + 1, 14 + refTextWidth, startY + 1);
        const refText = `DN. Ref No./Traffic / : ${EC_EPNo}`;
        const refX = 14;
        doc.text(refText, refX, startY);


        const refTextWidth = doc.getTextWidth(refText);
        doc.line(50, startY + 1, refX + refTextWidth, startY + 1);


        
        const dateText = `Date : ${formattedDate}`;
        const dateX = 150;
        doc.text(dateText, dateX, startY);

        // Draw underline for dateText
        const dateTextWidth = doc.getTextWidth(dateText);
        doc.line(160, startY + 1, dateX + dateTextWidth, startY + 1);


    // Heading
    startY += 15;
    doc.setFontSize(14);
    doc.setFont('times', 'bold');
    doc.text("DEBIT NOTE FOR TRAFFIC VIOLATIONS", 105, startY, { align: "center" });
    doc.setLineWidth(0.5);
    const headingWidth = doc.getTextWidth("DEBIT NOTE FOR TRAFFIC VIOLATIONS");
    doc.line(105 - headingWidth / 2, startY + 1, 105 + headingWidth / 2, startY + 1);

    // Body text
    doc.setFontSize(12);
    doc.setFont('times', 'normal');
    startY += 12;
    doc.text(`Against M/S`, 14, startY);
    doc.line(35, startY + 1, 120, startY + 1);
    doc.text(VehicleOwner, 42, startY);

    startY += 6;
    doc.text(`EC / EP No.`, 14, startY);
    doc.line(35, startY + 1, 67, startY + 1);
    doc.text(EC_EPNo, 36, startY);

    doc.text(`Vendor Code`, 67, startY);
    doc.line(90, startY + 1, 120, startY + 1);
    doc.text(VendorCode, 92, startY);

    doc.text(`on dated`, 121, startY);
    doc.line(136, startY + 1, 160, startY + 1);
        doc.text(formattedDate, 137, startY);

    doc.text(`at`, 162 , startY);
    doc.line(165, startY + 1, 185, startY + 1);
        doc.text(formattedTime, 167, startY);
        doc.text(`Hrs.`, 187, startY);
    startY += 7;
    doc.text(`vehicle belonging to`, 14, startY);
    doc.line(48, startY + 1, 100, startY + 1);
    doc.text(VehicleOwner, 55, startY);

    doc.text(`Registered Number`, 104, startY);
    doc.line(139, startY + 1, 190, startY + 1);
    doc.text(RegistrationNumber, 140, startY);

    startY += 6;
    doc.text(`Driven by`, 14, startY);
    doc.line(32, startY + 1, 90, startY + 1);
    doc.text(VehicleOwner, 40, startY);

    doc.text(`having driving licence number`, 94, startY);
    doc.line(148, startY + 1, 175, startY + 1);
    doc.text(LicenceNo, 150, startY);

    startY += 6;
    let text = `was found violating the traffic rules as per the details given in the Annexure - 2.`;
    let splitText = doc.splitTextToSize(text, 180);
    doc.text(splitText, 14, startY);

    startY += 12;
    text = `Since this kind of culpable transgressions & violations are very potential hazard for the life & property all the premises of Reliance, such negligent & rash action are required to be curbed & discouraged.`;
    splitText = doc.splitTextToSize(text, 180);
    doc.text(splitText, 14, startY);

    startY += splitText.length * 6 + 4;
    text = `It is therefore, proposed to raise a debit note of Rs.`;
    doc.text(text, 14, startY);
    doc.line(99, startY + 1, 118, startY + 1);
        doc.text(ChallanAmount, 101, startY);
        doc.text(`(Rs.`, 120, startY);
    doc.line(127, startY + 1, 171, startY + 1);
    doc.text(`${AmountInWords} Only`, 129, startY);
        doc.text(`) on such`, 172, startY);
        startY += 4; 
        doc.text(`Person.`, 14, startY);


    startY += 11;
    text = `Account Dept : is being advised to deduct the said amount from the / wages of the said contractor/person.`;
    splitText = doc.splitTextToSize(text, 180);
    doc.text(splitText, 14, startY);

    startY += splitText.length * 6 + 4;
    text = `Representation, if any, against the proposed debit note may be addressed to the COO-RGSS within a period of Ten days from the receipt of this notice (Annexure-2).`;
    splitText = doc.splitTextToSize(text, 180);
    doc.text(splitText, 14, startY);

    startY += splitText.length * 6 + 8;
    doc.setFont('times', 'bold');
    doc.text("Head Security", 14, startY);
    startY += 6;
    doc.setFont('times', 'normal');
    doc.text("Authorised Signatory", 14, startY);

    startY += 12;
    doc.setFont('times', 'bold');
    doc.text("CC : Accounts Dept :", 14, startY);

    startY += 6;
    //doc.setFont('times', 'normal');
    //text = `Please deduct ${ChallanAmount} (Rupees ${AmountInWords} Only) from the bill / wages of the above mentioned person / contractor for the violation committed by him / his employee as per debit note raised.`;
    //splitText = doc.splitTextToSize(text, 180);
        //doc.text(splitText, 14, startY);
        doc.setFont('times', 'normal');
        doc.text("Please deduct Rs.", 14, startY);
        doc.line(43, startY + 1, 80, startY + 1); 
        doc.text(ChallanAmount, 50, startY);
        doc.text("(Rs.", 82, startY);

        
        doc.line(90, startY + 1, 140, startY + 1); 
        doc.text(`${AmountInWords} Only`, 95, startY);

        doc.text(") from the bill / wages of the ", 142, startY);
        startY += 5;
        doc.text(`above mentioned person / contractor for the violation committed by him / his employee as per debit note`, 14, startY);
        startY += 5;
        doc.text(`raised.`, 14, startY);

    startY += splitText.length * 6 + 1;
    text = `Note : In case of MOU contractor, the amount is to be deducted out of the profit & not allowed to be added to the cost.`;
    splitText = doc.splitTextToSize(text, 180);
    doc.text(splitText, 14, startY);

    startY += splitText.length * 6 + 5;
    doc.text("Encl:-", 14, startY);
    startY += 6;
    doc.text("1. A brief report of the incident", 14, startY);
    startY += 6;
    doc.text("2. Debit note Annexure 2", 14, startY);

    // Image placement
    if (violationImage) {
        const imageX = 80;
        const imageY = startY - 20;
        const imageWidth = 100;
        const imageHeight = 55;
        doc.addImage(violationImage, 'PNG', imageX, imageY, imageWidth, imageHeight);
    }

    doc.save(`DebitNote_${RegistrationNumber}.pdf`);
};





    const GetViolationImage = (RecordID) => {
        if (RecordID != null) {
    debugger;
    // UserValidated
    fetch(apiEndpoint+"/GetViolationLogImages",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            "RecordID": RecordID,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      })
      .then(res => res.json())
      .then(
        (result) => {
        
          if (result != undefined || result != "") {
            // console.log(result);
            if (result.Message == "File not found!") {
              console.log("No Image found!!");
              setAlert(
                <ReactBSAlert
                  warning
                  //   style={bsAlertStyle}
                  //   title="Good job!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="warning"
                >
                  {result.Message}
                </ReactBSAlert>
              )
            }
            else {
              setImageData(result);
            }

          }
          else {
            console.log("No Image found!!");
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          //console.log(error);
          // /setError(error);
        }
      )
    // }, [props.ImgPath])

  }

};


const DownloadChallan = (violationData, NewANPRVal) => 
{
  debugger;
  // UserValidated
  fetch(apiEndpoint+"/SaveChallanGenerationLogs",
  {
    mode: "cors",
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      //'Access-Control-Allow-Origin': '*',
    },
    body: JSON.stringify({
              "RecordID": violationData.RecordID,
              "CampusID": violationData.CampusID,
              "LocationID": violationData.LocationID,
              "IncidentTime": violationData.IncidentTime,
              "ChallanAmount": NewChallanAmount,
              "ChallanType": ChallanType,
              "VehicleSpeed": violationData.VehicleSpeed,
              "RegistrationNumber": NewANPRVal,
              "strToken": sessionStorage.getItem("Clear_AuthUser")
            }) 
  })
  .then(res => res.json())
  .then((data) => {
    debugger;

    if (data.ChallanID != null) {
      debugger;
        DownloadPDF(violationData,NewANPRVal,data.ChallanID);

    }
    else {
      
    }

  });
}

const  EmailChallanToVehicleOwner = (pdfData, violationData) =>{
  debugger;
  // const pdf = new jsPDF();
  // pdf.text('Hello, World!', 10, 10);
  // const pdfData = pdf.output('datauristring');

  // UserValidated
  fetch(apiEndpoint+"/GetChallanPDF",
  {
    mode: "cors",
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      //'Access-Control-Allow-Origin': '*',
    },
    body: JSON.stringify({ pdfData: pdfData,
     VehicleOwnerName: violationData.VehicleOwnerName,
    VehicleOwnerEmail: violationData.VehicleOwnerEmailAddress,
    IncidentTime: violationData.IncidentTime,
    CampusName: violationData.CampusName,
    LocationName: violationData.LocationName,
    RegistrationNumber: violationData.RegistrationNumber,
    CampusID: violationData.CampusID,
    strToken: sessionStorage.getItem("Clear_AuthUser")
    }) 
            
  })
  .then(res => res.json())
  .then((data) => {
    debugger;
    console.log(data);
    setModalOpen(false);
    if(data.Message == "success")
    setAlert(
      <ReactBSAlert
        success
        //   style={bsAlertStyle}
        title="Email has been sent!"
        onConfirm={() => setAlert(null)}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="info"
      >
      </ReactBSAlert>
    )
    else{
      setAlert(
        <ReactBSAlert
          warning
          //   style={bsAlertStyle}
          title="Vehicle Owner Email Address in Not Available"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="warning"
        >
        </ReactBSAlert>
      )
    }

  });

}

const toggle = () => {

    setModalIsOpen(!modalIsOpen)
   
  }

const SaveViolation = (violationData, NewANPRVal) => {
    debugger;
    
    setTotalViolationFreq(violationData.TotalViolationFrequency);
    // UserValidated
    fetch(apiEndpoint+"/UpdateViolationANPRLog",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "RecordID": violationData.RecordID,
          //"IncidentTime": violationData.IncidentTime,
          "RegistrationNumber": NewANPRVal,
          "Token": sessionStorage.getItem("Clear_AuthUser")
        })
      })

      // const updatedData = await response.json();
      // return updatedData;
      .then(res => res.json())
      .then(
        (result) => {
          if (result != undefined) {
            //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
            console.log(result);
            if (result.Violations != undefined) {
              setAlert(
                <ReactBSAlert
                  success
                  //   style={bsAlertStyle}
                  title="Data Saved Successfully!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="info"
                >
                </ReactBSAlert>
               
              )
              debugger;
              var recdID = JSON.parse(result.Violations).RecordID;
              newdata = violations.slice();
            // newdata.find(someobject => someobject.RecordID == recdID).ViolationData = JSON.parse(result.Violations)  ;
        newdata.find((someobject) => {
                        if(someobject.RecordID === recdID){
                        someobject.RegistrationNumber = NewANPRVal;
                        someobject.VehicleOwnerName = JSON.parse(result.Violations).VehicleOwnerName;
                        someobject.VehicleOwnerDept = JSON.parse(result.Violations).VehicleOwnerDept;
                        someobject.ManagerName = JSON.parse(result.Violations).ManagerName;
                        someobject.VehicleOwnerContact = JSON.parse(result.Violations).VehicleOwnerContact;
                        someobject.VehicleOwnerEmailAddress = JSON.parse(result.Violations).VehicleOwnerEmailAddress;
                        someobject.EditDeleteStatus = JSON.parse(result.Violations).EditDeleteStatus;
              }} );

             // CompanyLocationName = newdata.find(log => log.RecordID == recdID).LocationName;
              setTotalViolationFreq(JSON.parse(result.Violations).TotalViolationFrequency);
              setViolations(newdata);
              console.log("Save Data--->", newdata);


              setshowGenerateChallanButton(true);
            }
            else {
              setAlert(
                <ReactBSAlert
                  warning
                  //   style={bsAlertStyle}
                  title="Something went wrong!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="warning"
                >
                  {result.Message}
                </ReactBSAlert>
              )
            }
          }
          else {
            setAlert(
              <ReactBSAlert
                warning
                //   style={bsAlertStyle}
                title="Something went wrong!"
                onConfirm={() => setAlert(null)}
                onCancel={() => setAlert(null)}
                confirmBtnBsStyle="warning"
              >
                {result.Message}
              </ReactBSAlert>
            )
          }
        }
      )
  }

  const handleEmailPDFCheck = () => {
    debugger;
    setEmailPDFCheck(true);

  };

  const handleEmailAction = (violationData, NewANPRVal) => {
    debugger;
    const emailPromise = new Promise((resolve, reject) => {
      debugger;
    
      resolve();
    });
  
    emailPromise.then(() => {
      handleEmailPDFCheck();
    }).catch((error) => {
      // Handle error if any Promise in the chain encounters an issue
    });
  };

  const SendEmailToVehicleOwner = (violationData, NewANPRVal) =>{
    debugger;

    if(violationData.VehicleOwnerEmailAddress != null)
    {
      // UserValidated
      fetch(apiEndpoint+"/SendEmailToRegisteredVehicleOwner",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "RecordID": violationData.RecordID,
          //"IncidentTime": violationData.IncidentTime,
          "RegistrationNumber": NewANPRVal,
          "LocationName": violationData.LocationName,
          "CampusName": violationData.CampusName,
          "CampusID": violationData.CampusID,
          "LocationID": violationData.LocationID,
          "VehicleOwnerName": violationData.VehicleOwnerName,
          "VehicleOwnerContact": violationData.VehicleOwnerContact,
          "VehicleOwnerEmailAddress": violationData.VehicleOwnerEmailAddress,
          "ManagerName": violationData.ManagerName,
          "VehicleOwnerDept": violationData.VehicleOwnerDept,
          "IncidentDateTime": violationData.IncidentTime,
          "VehicleSpeed": violationData.VehicleSpeed,
            "DailyViolationFrequency": violationData.TotalViolationFrequency,
            "ManualEmailStatus": true,
  
          "Token": sessionStorage.getItem("Clear_AuthUser")
        })
      })
        .then(res => res.json())
        .then((data) => {
         debugger;
      
   
      if(data.responseType == "success")
      setAlert(
        <ReactBSAlert
          success
          //   style={bsAlertStyle}
          title="Email sent Successfully !"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="info"
        >
        </ReactBSAlert>
        
        
      )
      else{
        setAlert(
          <ReactBSAlert
            warning
            //   style={bsAlertStyle}
            title="Vehicle Owner Email Address in Not Available"
            onConfirm={() => setAlert(null)}
            onCancel={() => setAlert(null)}
            confirmBtnBsStyle="warning"
          >
          </ReactBSAlert>
        )
      }
  
  
  })
    }
    else{
      setAlert(
        <ReactBSAlert
          warning
          //   style={bsAlertStyle}
          title="Vehicle Owner Email Address is Not Available"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="warning"
        >
        </ReactBSAlert>
      )
    }
    


  };

  const SendSMSToVehicleOwner = (violationData, NewANPRVal) =>{
    debugger;

    if(violationData.VehicleOwnerContact != null)
    {
      // UserValidated
      fetch(apiEndpoint+"/SendSMSToRegisteredVehicleOwnerContact",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "RecordID": violationData.RecordID,
          //"IncidentTime": violationData.IncidentTime,
          "RegistrationNumber": NewANPRVal,
          "LocationName": violationData.LocationName,
          "VehicleOwnerName": violationData.VehicleOwnerName,
          "VehicleOwnerContact": violationData.VehicleOwnerContact,
          "VehicleOwnerEmailAddress": violationData.VehicleOwnerEmailAddress,
          "IncidentDateTime": violationData.IncidentTime,
          "VehicleSpeed": violationData.VehicleSpeed,  
          "Token": sessionStorage.getItem("Clear_AuthUser")
        })
      })
        .then(res => res.json())
        .then((data) => {
         debugger;
      
   
      if(data.responseType == "success")
      setAlert(
        <ReactBSAlert
          success
          //   style={bsAlertStyle}
          title="Text Message sent Successfully !"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="info"
        >
        </ReactBSAlert>
        
        
      )
      else{
        setAlert(
          <ReactBSAlert
            warning
            //   style={bsAlertStyle}
            title="Vehicle Owner Contact is Not Available"
            onConfirm={() => setAlert(null)}
            onCancel={() => setAlert(null)}
            confirmBtnBsStyle="warning"
          >
          </ReactBSAlert>
        )
      }
  
  
  })
    }
    else{
      setAlert(
        <ReactBSAlert
          warning
          //   style={bsAlertStyle}
          title="Vehicle Owner  Contact is Not Available"
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          confirmBtnBsStyle="warning"
        >
        </ReactBSAlert>
      )
    }
    


  };

  useEffect(() => {
    if (EmailPDFCheck) {
      debugger;
      DownloadChallan(props.ViolationData, ANPRVal);
      setEmailPDFCheck(false);
       
    }
  }, [EmailPDFCheck]);
  
  const DeleteViolation = (violationData) => {
    // UserValidated
    fetch(apiEndpoint+"/DeleteViolationANPRLog",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "RecordID": violationData.RecordID,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      })
      .then(res => res.json())
      .then(
        (result) => {
          if (result != undefined) {
            //console.log(result);
            if (result.Violations != undefined) {
              setAlert(
                <ReactBSAlert
                  success
                  //   style={bsAlertStyle}
                  title="Record Deleted Successfully!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="info"
                >
                </ReactBSAlert>
              )

              var recdID = JSON.parse(result.Violations).RecordID;
              let newdata = violations.slice();
              var elindex=newdata.findIndex(someobject => someobject.RecordID == recdID);
              //delete newdata[elindex];
              newdata.splice(elindex, 1);
              setViolations(newdata);
            }
            else {
              setAlert(
                <ReactBSAlert
                  warning
                  //   style={bsAlertStyle}
                  title="Something went wrong!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="warning"
                >
                  {result.Message}
                </ReactBSAlert>
              )
            }
          }
          else {
            setAlert(
              <ReactBSAlert
                warning
                //   style={bsAlertStyle}
                title="Something went wrong!"
                onConfirm={() => setAlert(null)}
                onCancel={() => setAlert(null)}
                confirmBtnBsStyle="warning"
              >
                {result.Message}
              </ReactBSAlert>
            )
          }
        }
      )
  }
    const formatDate = (dateString) => {
        if (!dateString) return "NA";
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");

        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12; // 12 AM/PM format

        return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    };

    const sortedByOldest = [...regNoViolations].sort((a, b) =>
        new Date(a.DateTime) - new Date(b.DateTime)
    );

    sortedByOldest.forEach((item, index) => {
        item.DisplayFrequency = (index % 3) + 1;
    });
  return (
    <>
      <Link to='#'
        onClick={() => {
          const decodedToken = jwt.decode(sessionStorage.getItem("Clear_AuthUser"));
          var UserPermissions=JSON.parse(decodedToken.userRolePermissions);
          // var UserPermissions=JSON.parse(sessionStorage.getItem("UserRolePermissions"));
          GetViolationImage(props.ViolationData.RecordID);
          setShowDeleteButton(UserPermissions.DeleteViolations);
          
          setANPR(props.ViolationData.RegistrationNumber);
         
          if(props.ViolationData.EditDeleteStatus == "01")
          {
            setshowGenerateChallanButton(true);

          }
          else{
            setshowGenerateChallanButton(false);
          }
          toggle();
          
        }}
        ><i className=" mdi mdi-border-color mdi-24px"></i></Link>
      
      {modalIsOpen==true && alertmsg}
      {props.ViolationData != undefined && imgData!=undefined &&
        <Modal isOpen={modalIsOpen} style={{ maxWidth: "60%" }}>

          <ModalHeader toggle={toggle} tag="h4">
          </ModalHeader>
          <ModalBody>
            <AvForm className="needs-validation">
              {/* {props.ViolationData.RegistrationNumber} */}
              <Row>
                {/* <ActiveImageContext.Provider value={ImgContextvalue} > */}
                <Slidewithindicator ImagePath={imgData} ImageIndex={setViolationImageIndex}/>
                {/* </ActiveImageContext.Provider> */}
               
              </Row>

              <Row>

                <Col md={12}>
                  <label for="RegistrationNumberid" className="mt-3">Registration Number</label>
                 <AvField
                    name="RegistrationNumberid"
                    placeholder="Registration Number"
                    type="text"
                    className="form-control"
                    value={props.ViolationData.RegistrationNumber}
                    id="registrationNumberid"
                    onChange={(event) => setANPR(event.target.value)}
                  />
                </Col>
                <Col md={12}>
                  {showDeleteButton &&
                    <button className=" mt-3  mdi mdi-delete  btn btn-primary mdi-18px"
                    id="DeleteBtnID"
                    onClick={() => {
                      DeleteViolation(props.ViolationData);
                      toggle();
                    }}></button>

                  }
                
               
                  <button className=" mt-3 mx-2 mdi mdi-content-save btn btn-primary mdi-18px"
                  id="SaveBtnID"
                    onClick={() => {
                      SaveViolation(props.ViolationData, ANPRVal)
                    //  console.log(props.ViolationData);
                    }} ></button>

                { showGenerateChallanButton &&
                <button className=" mt-3 mdi mdi-format-float-left btn btn-primary mdi-18px"
                    to="#" role="Button" id="ChallanBtn"
                    onClick={() => {
                      setEmailPDFCheck(false);
                      GetChallanConfig(props.ViolationData);
                      tog_small();                    
                      setModalOpen(true);
                      
                     
                    }} ></button>
                  }

                    { showGenerateChallanButton &&  showEmailButton &&
                      <button className=" mt-3 mx-2 mdi mdi-email btn btn-primary mdi-18px"
                          to="#" role="Button" id="EmailBtnID"
                          onClick={() => {
                            SendEmailToVehicleOwner(props.ViolationData,ANPRVal);
                           
                            
                           
                          }} ></button>


                }

                { showGenerateChallanButton && showSMSButton &&
                      <button className=" mt-3  mdi mdi-message-text btn btn-primary mdi-18px"
                          to="#" role="Button" id="TextMsgBtnID"
                          onClick={() => {
                            SendSMSToVehicleOwner(props.ViolationData, ANPRVal);
                            
                           
                          }} ></button>

                          
                }
               {showDeleteButton &&  <UncontrolledTooltip placement="top" target="DeleteBtnID">
                                                           Delete
                                                        </UncontrolledTooltip>
}
                                              {showSMSButton && showGenerateChallanButton &&
                                                 <UncontrolledTooltip placement="top" target="TextMsgBtnID">
                                                          Text Message
                                                        </UncontrolledTooltip> 
                                              }  

<UncontrolledTooltip placement="top" target="SaveBtnID">
                                                          Save
                                                        </UncontrolledTooltip>
{ showGenerateChallanButton && 
    <UncontrolledTooltip placement="top" target="ChallanBtn">
    Challan
  </UncontrolledTooltip>}
{ showGenerateChallanButton && showEmailButton &&
 <UncontrolledTooltip placement="top" target="EmailBtnID">
 E-Mail
</UncontrolledTooltip>}

                                                      
                                                    
                                                       
                                                       
                                                      
                </Col>
              </Row>
            </AvForm>
          </ModalBody>

        </Modal>
       
      }
         {modalOpen ?
      <Modal 
        isOpen={modal_small}
        style={{ maxWidth: "60%" }}
                  size="xl"
        // toggle={() => {
        //   tog_small()

        // }}

      >
       <ModalHeader toggle={ () => {
          tog_small()

        }} tag="h1">
          </ModalHeader>
        <ModalBody to='#'>

                      <Row className="mb-3 align-items-center">

                          <label className="col-md-3 col-form-label">
                              Challan Type
                          </label>

                          <div className="col-md-5">
                              <Select
                                  value={SelectedChallanType}
                                  options={ChallanTypeDropdown}
                                  onChange={handleChangeChallanType}
                              />
                          </div>

                          <div className="col-md-4 d-flex justify-content-start">
                              <button
                                  type="submit"
                                  className="btn btn-primary mdi mdi-download mdi-12px"
                                  onClick={() => { DownloadChallan(props.ViolationData, ANPRVal); }}
                              >
                                  Download
                              </button>
                          </div>

                      </Row>
                      <Row className="mb-3 align-items-center">

                          <label className="col-sm-3 col-form-label">
                              Violation Frequency
                          </label>

                          <div className="col-sm-5">
                              <input
                                  className="form-control"
                                  type="text"
                                  defaultValue={TotalViolationFreq}
                                  disabled
                              />
                          </div>

                          <div className="col-sm-4 d-flex">
                              {showEmailButton && (
                                  <Button
                                      color="primary"
                                      className="ml-2"
                                      onClick={() => SendEmailToVehicleOwner(props.ViolationData)}
                                  >
                                      Email
                                  </Button>
                              )}
                          </div>

                      </Row>


         
                      <Row>
                          <div className="col-12 mt-4">
                              <h5 className="mb-3 text-primary">Vehicle & Violation Details</h5>
                              <div className="table-responsive">
                                  <table className="table table-bordered table-striped">
                                      <thead className="table-light">
                                          <tr>
                                              <th>Sr.No.</th>
                                              <th>Owner Name</th>
                                              <th>Registration Number</th>
                                              <th>Email</th>
                                              <th>Violation Location</th>
                                              <th>Date & Time</th>
                                              <th>Vehicle Speed</th>
                                              <th>Speed Limit</th>
                                              <th>Email Status</th>
                                              <th>Violation Frequency</th>
                                          </tr>
                                      </thead>

                                      <tbody>
                                          {regNoViolations.length > 0 ? (
                                              regNoViolations.map((item, index) => {
                                                  debugger;
                                                  
                                                  let emailStatusText = "";
                                                  if (item.ManualEmailStatus === true || item.ManualEmailStatus === 1) {
                                                      emailStatusText = `Email sent manually at ${formatDate(item.ManualEmailSentOn)}`;
                                                  } else {
                                                      if (item.EmailStatus === 1 || item.EmailStatus === "Sent") {
                                                          if (!item.Email || item.Email === "") {
                                                              emailStatusText = `Email sent to Admin at ${formatDate(item.DateTime)}`;
                                                          } else {
                                                              emailStatusText = `Email sent to ${item.Email} at ${formatDate(item.DateTime)}`;
                                                          }
                                                      } else if (item.EmailStatus === "Pending") {
                                                          emailStatusText = "Pending";
                                                      }
                                                  }
                                                
                                                  const emailColor =
                                                      item.ManualEmailStatus === true
                                                          ? "purple"   
                                                          : (item.EmailStatus === 1 || item.EmailStatus === "Sent")
                                                          ? "green"
                                                          : "red";

                                                  return (
                                                      <tr key={index}>
                                                          <td>{index + 1}</td>
                                                          <td>{item.OwnerName}</td>
                                                          <td>{item.RegistrationNumber}</td>
                                                          <td>{item.Email}</td>
                                                          <td>{item.ViolationLocation}</td>
                                                          <td>{formatDate(item.DateTime)}</td>
                                                          <td>{item.VehicleSpeed}</td>
                                                          <td>{item.SpeedLimit}</td>

                                                       
                                                          <td style={{ color: emailColor }}>
                                                              {emailStatusText}
                                                          </td>

                                                          <td
                                                              style={{ cursor: "pointer", fontWeight: "bold", color: "blue" }}
                                                              onClick={() => handleFrequencyClick(item.ViolationFrequency, item.RegistrationNumber)}
                                                          >{item.DisplayFrequency}</td>
                                                      </tr>
                                                  );
                                              })
                                          ) : (
                                              <tr>
                                                  <td colSpan="11" className="text-center">
                                                      No violations found
                                                  </td>
                                              </tr>
                                          )}
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                      </Row>

         
          
        
        

        
        </ModalBody>
       <ModalFooter>
       
       </ModalFooter>
      </Modal>
              : ""}
          {showFreqModal && (
              <Modal
                  isOpen={showFreqModal}
                  toggle={() => setShowFreqModal(false)}
                  size="xl"
                  style={{ maxWidth: "50%" }}  // bigger modal
              >
                  <ModalHeader toggle={() => setShowFreqModal(false)} className="text-primary">
                      Previous Violations (Frequency: {freqViolations.length})
                  </ModalHeader>

                  <ModalBody>

                      {freqViolations.length > 0 ? (
                          <div className="table-responsive">
                              <table className="table table-bordered table-striped table-hover">
                                  <thead className="table-light">
                                      <tr>
                                          <th>Sr.No</th>
                                          <th>Registration</th>
                                          <th>Location</th>
                                          <th>Date & Time</th>
                                          <th>Speed</th>
                                          <th>Limit</th>
                                      </tr>
                                  </thead>

                                  <tbody>
                                      {freqViolations.map((v, i) => (
                                          <tr key={i}>
                                              <td>{i + 1}</td>
                                              <td>{v.RegistrationNumber}</td>
                                              <td>{v.ViolationLocation}</td>
                                              <td>{v.DateTime}</td>
                                              <td>{v.VehicleSpeed}</td>
                                              <td>{v.SpeedLimit}</td>
                                          </tr>
                                      ))}
                                  </tbody>
                              </table>
                          </div>
                      ) : (
                          <p>No previous violations found.</p>
                      )}

                  </ModalBody>

                  <ModalFooter>
                  
                  </ModalFooter>
              </Modal>
          )}


    </>
  
  )

}


export default EditViolationModalComponent;